import { toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useSearchContext } from '../../../searchContext/SearchContextProvider.js';
import ErrorBoundary from '../../../util/ErrorBoundary.js';
import { List, ListItem } from '@vp/swan';

var ErrorBoundaryWrapper = function ErrorBoundaryWrapper(_ref) {
  var shouldWrap = _ref.shouldWrap,
    component = _ref.component,
    children = _ref.children;
  var _useSearchContext = useSearchContext(),
    logger = _useSearchContext.logger;
  if (shouldWrap) {
    return /*#__PURE__*/React__default.createElement(ErrorBoundary, {
      logger: logger,
      component: component
    }, children);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
};
var getRendererWithHeadingForResultType = (function (Result, Footer) {
  var useSectionErrorBoundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var useResultErrorBoundary = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return function (taxonomyHeadingLocalizer) {
    return function (_ref2) {
      var results = _ref2.results,
        maxResults = _ref2.maxResults,
        taxonomyConfiguration = _ref2.taxonomyConfiguration,
        headerId = _ref2.headerId,
        fillToMaxResults = _ref2.fillToMaxResults;
      var _useSearchContext2 = useSearchContext(),
        locale = _useSearchContext2.locale;
      var resultsToRender = [];
      if (fillToMaxResults && taxonomyConfiguration) {
        resultsToRender = fillAllResultSlots(taxonomyConfiguration, maxResults, results);
      } else if (taxonomyConfiguration) {
        Object.keys(taxonomyConfiguration).forEach(function (resultType) {
          var limit = taxonomyConfiguration[resultType];
          var count = 0;
          results.forEach(function (result) {
            if (result.resultType === resultType && count < limit && resultsToRender.length < (maxResults || Infinity)) {
              resultsToRender.push(result);
              count++;
            }
          });
        });
      } else {
        resultsToRender = results.slice(0, maxResults || results.length);
      }
      return /*#__PURE__*/React__default.createElement(ErrorBoundaryWrapper, {
        shouldWrap: useSectionErrorBoundary,
        component: "".concat(headerId, "-section")
      }, /*#__PURE__*/React__default.createElement(List, {
        role: "group",
        skin: "minimal",
        p: 0,
        "aria-labelledby": "".concat(headerId)
      }, /*#__PURE__*/React__default.createElement(ListItem, {
        role: "presentation",
        marginTop: 5,
        fontSkin: "body-small",
        id: headerId
      }, taxonomyHeadingLocalizer(locale)), resultsToRender.map(function (result) {
        return /*#__PURE__*/React__default.createElement(ErrorBoundaryWrapper, {
          shouldWrap: useResultErrorBoundary,
          component: "".concat(headerId, "-").concat(result === null || result === void 0 ? void 0 : result.objectID, "-result"),
          key: result === null || result === void 0 ? void 0 : result.objectID
        }, /*#__PURE__*/React__default.createElement(Result, {
          result: result
        }));
      }), false));
    };
  };
});
function fillAllResultSlots(taxonomyConfiguration, maxResults, taxonomyResults) {
  var resultTypes = Object.keys(taxonomyConfiguration);
  var taxonomyResultsByType = resultTypes.reduce(function (acc, taxonomyType) {
    acc[taxonomyType] = taxonomyResults.filter(function (result) {
      return result.resultType === taxonomyType;
    });
    return acc;
  }, {});
  var pool = [];
  var result = Object.keys(taxonomyResultsByType).flatMap(function (taxomonyKey) {
    var taxonomyResults = taxonomyResultsByType[taxomonyKey];
    var resultTypeMax = taxonomyConfiguration[taxomonyKey];
    var resultTypeCount = taxonomyResults.length;
    if (resultTypeCount >= resultTypeMax) {
      pool.push.apply(pool, _toConsumableArray(taxonomyResults.slice(resultTypeMax)));
      return taxonomyResults.slice(0, resultTypeMax);
    } else {
      var needed = resultTypeMax - resultTypeCount;
      var fromPool = pool.splice(0, needed);
      return taxonomyResults.concat(fromPool);
    }
  });
  var remainingSlots = maxResults - result.length;
  if (remainingSlots > 0) {
    result.push.apply(result, _toConsumableArray(pool.slice(0, remainingSlots)));
  }
  return result;
}

export { getRendererWithHeadingForResultType as default };
//# sourceMappingURL=RendererWithLocalizedHeadingFactory.js.map
